export default __webpack_public_path__ + "static/media/notesLogo.9021010e.svg";